// Add these interfaces to your existing organization.ts file

export interface ClientFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role: string;
}

export interface CompanyFormData {
  name: string;
  description: string;
  website: string;
  phone?: string;
  address: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  timezone: string;
  cutoffHours: string;
}

export type PlanType = 'rag' | 'scheduler';
export enum planType {
  SCHEDULER = 'scheduler',
  RAG = 'rag',
}
export type PlanTypeValue = PlanType[keyof PlanType];

// Theme configuration for dynamic styling
export type BorderRadiusStyle = 'rounded' | 'soft' | 'sharp';

export interface ThemeConfig {
  primaryColor?: string; // Main brand color (default: #6366f1)
  primaryColorLight?: string; // Lighter variant (default: #818cf8)
  primaryColorDark?: string; // Darker variant (default: #4f46e5)
  accentColor?: string; // Accent/CTA color (default: #10b981)
  backgroundColor?: string; // Chat background (default: #ffffff)
  textColor?: string; // Primary text (default: #1f2937)
  textColorLight?: string; // Secondary text (default: #6b7280)
  bubbleUserBg?: string; // User message bubble (default: primaryColor)
  bubbleAgentBg?: string; // Agent message bubble (default: #f3f4f6)
  borderRadius?: BorderRadiusStyle; // Border radius style: 'rounded' | 'soft' | 'sharp'
}

export interface OrganisationFormData {
  companyName: string;
  client: ClientFormData;
  company: CompanyFormData;
  planType: PlanTypeValue;
  isBookingEnabled: boolean;
  resourceProfessional: string;
  bookingDescription: string;
  isVerifyBySMS: boolean;
  isChatDisabled?: boolean;
  isStripeEnabled?: boolean;
  dealerPromo?: string;
}

export interface Organisation {
  id: string;
  companyName: string;
  client: ClientFormData;
  company: CompanyFormData;
  planType: PlanType;
  isBookingEnabled: boolean;
  bookingDescription: string;
  chatDescription?: string;
  clientTableName?: string;
  ingest_status?: string;
  ingestStatus?: string; // API may return camelCase
  status?: string;
  isChatDisabled?: boolean;
  chatPrefills?: any[];
  isVerifyBySMS?: boolean;
  planId?: string;
  isTrailEnabled?: boolean;
  isStripeEnabled?: boolean;
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  resourceProfessional: string;
  createdAt: string;
  updatedAt: string;
  stripeSubscriptionId?: string;
  paymentMethodId?: string;
  stripeCustomerId?: string;
  themeConfig?: ThemeConfig;
  twilioCallAttemptLimit?: number; // Number of test calls made (max 3)
  dealerPromo?: string; // Links organization to a dealer
  phoneWelcomeMessage?: string; // Welcome message for phone callers
  isOnlineMeetingEnabled?: boolean; // Enable online meeting integrations (Zoom/Google Meet)
  blindCarbonCopyEmails?: string[]; // BCC emails for booking confirmation emails
  newBookingConfirmationMessage?: string; // Custom booking confirmation message template
  phoneBookingConsentMessage?: string; // Custom phone consent message for bookings
  phoneFormConsentMessage?: string; // Custom phone consent message for forms
}

export interface OrganisationResponse {
  items: Organisation[];
}

export interface OrganisationState {
  items: Organisation[];
  selectedOrganisation: Organisation | null;
  isLoading: boolean;
  error: string | null;
}

export interface requestOrganisation {
  companyName: string;
  firstName: string;
  email: string;
  planType: PlanType;
  paymentMethodId?: string;
  planId: string;
  isTrailEnabled?: boolean;
  stripeCustomerId?: string | undefined;
  isOAuthUser?: boolean; // Flag to indicate OAuth user (Google Sign-In)
  dealerPromo?: string;
}
